const PHONE_TYPE_DISPLAY_NAMES = {
  HOME: "Home",
  WORK: "Work",
  MOBILE: "Mobile",
  LANDLINE: "Landline",
  OTHER: "Other",
} as const;

export const GENERIC_PHONE_LABEL = "Phone";
export const PRIMARY_PHONE_LABEL = "Main";

const phoneTypeDisplayNames = new Map<string, string>(Object.entries(PHONE_TYPE_DISPLAY_NAMES));

// A module-level array would hand the same objects to every row's select, and filterList mutates the
// options it is given. Precautionary only: these selects leave search off, so nothing mutates today.
export const getPhoneTypeOptions = () =>
  Object.entries(PHONE_TYPE_DISPLAY_NAMES).map(([value, label]) => ({ value, label }));

interface PhoneRowLabelInput {
  phoneNotes?: string | null;
  isPrimary: boolean;
}

export const getPhoneRowLabel = ({ phoneNotes, isPrimary }: PhoneRowLabelInput) => {
  if (isPrimary) {
    // "Main" deliberately wins over a stored type. Some primaries do carry one (written by the DAO,
    // not the drawer), but the drawer shows the primary's type as a disabled "Main" — so rendering
    // the stored value here would contradict the only editor a rep can see.
    return PRIMARY_PHONE_LABEL;
  }
  // phoneNotes is a free String column the DAO stores verbatim, so normalize before lookup. It also
  // still holds values retired from the select (SPOUSE_PARTNER, FAMILY, MAIN), which fall back.
  return phoneTypeDisplayNames.get((phoneNotes ?? "").trim().toUpperCase()) ?? GENERIC_PHONE_LABEL;
};
